import styled from "styled-components";
import { theme } from "../../../config";

export const InputField = styled.div`
  margin-top: 20px;
`;

export const InputTitle = styled.p`
  color: ${theme.colors.dark};
  @media ${theme.breakpoints.mobileAndTablet} {
    font-size: 12.6px;
    line-height: 16px;
  }
`;
